const REMEMBER_ME_FIELD_NAMES = ['email', 'name', 'isMembership', 'loginType', 'loginSubtype'];
const EMPTY_STRING = '';

function getParsedRememberMeCookie() {
    const rememberMeCookie = getRememberMeCookie();
    const fieldValues = rememberMeCookie !== null
        ? decodeURIComponent(rememberMeCookie).split(';').map((field) => field.replace(/[#+]/g, ' '))
        : [];
    return _.zipObject(REMEMBER_ME_FIELD_NAMES, fieldValues);
}

function getRememberMeCookie() {
    return Odigeo.Utils.readCookie('sso_remember_me');
}

function isMembershipFromCookie() {
    const {isMembership} = getParsedRememberMeCookie();
    return isMembership === 'true';
}

function getNameFromCookie() {
    const {name} = getParsedRememberMeCookie();
    return name ?? EMPTY_STRING;
}

function getEmailFromCookie() {
    const {email} = getParsedRememberMeCookie();
    return email ?? EMPTY_STRING;
}

function getLoginTypeFromCookie() {
    const {loginType} = getParsedRememberMeCookie();
    return loginType ?? EMPTY_STRING;
}

function getLoginSubtypeFromCookie() {
    const {loginSubtype} = getParsedRememberMeCookie();
    return loginSubtype ?? EMPTY_STRING;
}

function isRememberMeCookiePresent() {
    return getRememberMeCookie() !== null;
}

module.exports = {
    getParsedRememberMeCookie,
    getEmailFromCookie,
    getLoginTypeFromCookie,
    getNameFromCookie,
    getLoginSubtypeFromCookie,
    isMembershipFromCookie,
    isRememberMeCookiePresent,
};
